import { useCallback, useId, useRef } from 'react';
import { useFocusTrap, useOnEscape, useScrollLock, } from '@hivebrite/react-hooks';
export const useSidePanel = ({ isOpen, onClose, }) => {
    const containerRef = useRef(null);
    const id = useId();
    useOnEscape(() => {
        if (isOpen) {
            onClose();
        }
    }, isOpen);
    useFocusTrap(containerRef, isOpen);
    useScrollLock(isOpen);
    const onContentKeyDown = useCallback((event) => {
        const content = event.currentTarget;
        const scrollAmount = 100;
        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                content.scrollBy({ top: scrollAmount, behavior: 'smooth' });
                break;
            case 'ArrowUp':
                event.preventDefault();
                content.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
                break;
            case 'PageDown':
                event.preventDefault();
                content.scrollBy({ top: content.clientHeight, behavior: 'smooth' });
                break;
            case 'PageUp':
                event.preventDefault();
                content.scrollBy({ top: -content.clientHeight, behavior: 'smooth' });
                break;
            case 'Home':
                event.preventDefault();
                content.scrollTo({ top: 0, behavior: 'smooth' });
                break;
            case 'End':
                event.preventDefault();
                content.scrollTo({ top: content.scrollHeight, behavior: 'smooth' });
                break;
        }
    }, []);
    return {
        containerRef,
        id,
        onContentKeyDown,
    };
};
//# sourceMappingURL=useSidePanel.js.map